// <www.sharporator.com[readonly.file]> do not change the file or delete this line

import React from 'react'
import EndpointsTestingComponent from './endpointsTestingComponent'
import Loading from '../../components-lib/loading'
import ErrorMessage from '../../components-lib/errorMessage'
import Success from '../../components-lib/success'
import {useAxios} from '../../hooks/useAxios'
    export default
        function CloseManageBusinessDayTestingEndpoints(
        props
        )
        {
            const [{response: closeManageBusinessDay, isLoading: closeManageBusinessDayLoading, error: closeManageBusinessDayError}, closeManageBusinessDayFetch, closeManageBusinessDayClear] = useAxios()
            const closeManageBusinessDayPost = 
                (closeManageBusinessDayParams, responseCallback, errorCallback, cancelCallback) => {
                    closeManageBusinessDayFetch({
                        url: `/Proxy/CloseManageBusinessDay`,
                        data: closeManageBusinessDayParams,
                        method: "post",
                        responseCallback,
                        errorCallback,
                        cancelCallback
                    });
                }
            function mainRender() {
                return (
                    <div className='container-lg'>
                        <div className='display-4'>CloseManageBusinessDayTestingEndpoints</div>
                    </div>
                )
            }
            return (
                <>
                    {mainRender()}
                    {closeManageBusinessDayLoading && <Loading isSaving/>}
                    {closeManageBusinessDayError && <ErrorMessage error={closeManageBusinessDayError} fetchForInit={closeManageBusinessDayClear}/>}
                    {closeManageBusinessDay && <Success/>}
                    <EndpointsTestingComponent
                        closeManageBusinessDay={closeManageBusinessDay}
                        onCloseManageBusinessDayPost={closeManageBusinessDayPost}
                        onCloseManageBusinessDayClear={closeManageBusinessDayClear}
                        {...props}
                    />
                </>
            )
        }
